<div class="title-wrapper flex">
  <h3 class="font-heading-4 ms-xsmall-r">{{ 'seatMap.seatTypesTitle' | finLocalization }}</h3>
  <fcom-icon-button
    *ngIf="(flight.seatMap$ | async)?.isWetlease === false"
    class="flex flex--self-center ms-xsmall-r"
    id="seat-type-read-more"
    [icon]="{ name: SvgLibraryIcon.INFO }"
    [theme]="IconButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
    [size]="IconButtonSize.SMALL"
    [aria]="{ label: 'readMore' | finLocalization }"
    aria-labelledby="seat-type-read-more"
    (clickBtn)="openModal()"
  >
  </fcom-icon-button>
</div>
<fcom-carousel
  class="block overflow-auto"
  [prevButtonAriaLabel]="'carousel.previous' | finLocalization"
  [nextButtonAriaLabel]="'carousel.next' | finLocalization"
>
  <div class="flex flex--nowrap">
    <fcom-tag-button
      *ngFor="let seatType of availableSeatTypes$ | async; let i = index"
      class="ms-small-y flex--inline"
      [class.ms-xsmall-l]="i !== 0"
      [attr.data-testid]="'seat-type-' + seatType.className"
      [theme]="TagTheme.DEFAULT"
      [iconCategory]="IconLibrary.CUSTOM"
      (tagClicked)="handleClick(seatType)"
    >
      <div class="flex">
        <div class="seat-type-svg flex-1 ms-xsmall-y">
          <svg class="icon-large block" viewBox="0 0 48 44" [innerHTML]="seatType.icon | finSafe: 'html'">
            {{ seatType.icon }}
          </svg>
        </div>
        <div class="flex-1 ms-xxsmall-t ms-xxsmall-l flex--grow">
          <div class="font-body-2 align-left">{{ seatType.label | finLocalization }}</div>
          <div class="font-body-2 align-left">
            <ng-container *ngIf="seatType.originalPrice">
              <span class="strike-through ms-xxsmall-r">{{ seatType.originalPrice | finPrice }},</span>
              <span class="heather-800-text">{{ seatType.price | finPrice }}</span>
            </ng-container>
            <ng-container *ngIf="!seatType.originalPrice">
              <span>{{ seatType.price | finPrice }}</span>
            </ng-container>
          </div>
        </div>
      </div>
    </fcom-tag-button>
  </div>
</fcom-carousel>

<fcom-modal
  class="seat-type-modal"
  title="{{ 'seatMap.seatTypesTitle' | finLocalization }}"
  [open]="seatTypeModalOpen"
  (close)="closeModal()"
  [buttons]="ModalButtons.CLOSE"
>
  <ng-container *ngIf="seatTypeModalOpen">
    <div class="relative" *ngIf="availableSeatTypesInModal">
      <ng-container *ngFor="let seatType of availableSeatTypesInModal">
        <div class="pr-large-x pr-xxsmall-y">
          <ng-container *ngIf="seatType.article$ | async as article">
            <div class="seat-type-wrapper flex flex--row ps-small-x ps-medium-y border-bottom">
              <div
                data-testid="seat-map-image"
                class="flex-1 flex--basis0 fill image-wrapper ps-medium-r ps-small-b"
                *ngIf="article.picture as imageData"
              >
                <fin-content-image class="rounded-large" [imageData$]="imageData | finToObservable"></fin-content-image>
              </div>
              <div class="flex-1 flex--basis0 fill">
                <cms-rich-text
                  [attr.data-testid]="'seat-type-title-' + article.contentId"
                  [extraClasses]="'font-body-1'"
                  [headerLevel]="2"
                  [content$]="seatType.article$"
                >
                </cms-rich-text>
              </div>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </div>
  </ng-container>
</fcom-modal>
